import React, { useState } from "react";
import { signIn } from "aws-amplify/auth";
import "./AdminLogin.css";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 👁️ eye toggle
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setError("");

    try {
      const user = await signIn({
        username: email,
        password: password,
      });

      // Save session for ProtectedRoute
      localStorage.setItem("loggedInUser", JSON.stringify(user));

      // Redirect to admin dashboard
      window.location.href = "/admin";
    } catch (err) {
      console.log("Login error:", err);
      setError("Invalid email or password");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <div className="login-page">
      <div className="glass-card login-card">

        {/* Logo */}
        <img
          src="/fulllogo.png"
          alt="Argencis Logo"
          className="login-logo"
        />

        <h2 className="login-title">Admin Login</h2>

        {/* Email Input */}
        <input
          type="email"
          placeholder="Enter email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        {/* Password + Eye Toggle */}
        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Enter password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
          />

          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : "👁️"}
          </span>
        </div>

        {/* Login Button */}
        <button className="login-btn" onClick={handleLogin}>
          Login
        </button>

        {/* Forgot Password */}
        <p
          className="forgot-password-text"
          style={{
            cursor: "pointer",
            color: "#007bff",
            marginTop: "10px",
            fontSize: "14px",
          }}
          onClick={() => (window.location.href = "/admin/forgot-password")}
        >
          Forgot Password?
        </p>

        {/* Error Message */}
        {error && <p className="login-error">{error}</p>}

        <p className="login-footer">Authorized personnel only</p>

      </div>
    </div>
  );
}

export default AdminLogin;
